

import ImagesCarousel from "./ImagesCarousel";
import BenchProducts from "./BenchProducts";
import FAQs from './FAQs'
import ImageCardsBlock from './ImageCardsBlock'

export default {
  plugins: {
    content: [ImagesCarousel, BenchProducts, FAQs, ImageCardsBlock],

  },
};
